import { useCallback } from 'react';
import { OrgUserService } from '@api/OrgUserService';
import { invalidateOrgUserData } from '@stores/orgUserStore';

type DeleteOrgUser = (userId: string) => Promise<true>;

const useDeleteOrgUser = (orgId?: string): { deleteOrgUser: DeleteOrgUser } => {
    const deleteOrgUser = useCallback<DeleteOrgUser>(
        async (userId) => {
            if (!orgId) {
                throw new Error('useDeleteOrgUser requires an org id');
            }

            await OrgUserService.deleteOrgUser(orgId, userId);

            invalidateOrgUserData();

            return true;
        },
        [orgId],
    );

    return { deleteOrgUser };
};

export default useDeleteOrgUser;
